/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['../selector'], function(selector) {
    'use strict';
    return function(json) {
        return selector(json, 'results', 'address, dist, position, score,' +
            ' type, addressRanges, boundingBox, viewport') || {};
    };
});



// WEBPACK FOOTER //
// ./model/geocode/geocode.js